import type { IComponentController } from "angular";
import type { IHolidayConfiguration, IWeeklySchedule } from "App/Modules/Models";
import { DayTypeFunctions } from "App/Modules/Models";

export default class TemporaryWeeklyScheduleComponentController implements IComponentController {
    public holidaySchedule: IWeeklySchedule;

    public holidayConfigurations: IHolidayConfiguration;

    public partnerId: string;

    public groupTypeName: string;

    public dayTypes = DayTypeFunctions.HolidayDaysMap();
}
